module.exports = __webpack_public_path__ + "img/icon-WAIT-IN.438be101.png";